module.exports = __webpack_public_path__ + "assets/img/202111-3.ee951f6b.png";